export default __webpack_public_path__ + "static/media/pic12.a6f09c7f.jpg";